var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"svg-icon-wrapper-pc",domProps:{"innerHTML":_vm._s(_vm.icon)}}):_c('v-progress-circular',{attrs:{"indeterminate":"","width":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }